<div class="submission-score-container">
  <ng-container *ngIf="submissionData$ | async as data">

    <!-- Loading State -->
    <div class="loading-overlay" *ngIf="data.scoreLoading">
      <mat-spinner diameter="48"></mat-spinner>
      <span>Retrieving your submission score...</span>
    </div>

    <ng-container *ngIf="!data.scoreLoading">

      <!-- Header -->
      <div class="score-header">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <div>
          <h1>MIPS Submission Confirmation</h1>
          <p class="subtitle">Your submission for the {{ data.performanceYear }} performance year has been successfully received.</p>
        </div>
      </div>

      <!-- Submission Details -->
      <div class="score-section">
        <h2>Submission Details</h2>
        <table class="details-table">
          <tbody>
            <tr>
              <td class="detail-label">Program Year</td>
              <td class="detail-value">{{ data.performanceYear }}</td>
            </tr>
            <tr *ngIf="data.isIndividual">
              <td class="detail-label">NPI</td>
              <td class="detail-value">{{ data.npi }}</td>
            </tr>
            <tr>
              <td class="detail-label">TIN</td>
              <td class="detail-value">{{ data.tin }}</td>
            </tr>
            <tr>
              <td class="detail-label">Submission Method</td>
              <td class="detail-value">Registry</td>
            </tr>
            <tr>
              <td class="detail-label">Submission Date</td>
              <td class="detail-value">{{ data.submittedDate | date:'MMMM d, y, h:mm a' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Category Performance -->
      <div class="score-section" *ngIf="!data.scoreError && data.categoryScores?.length > 0">
        <h2>Category Performance</h2>
        <table class="category-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Status</th>
              <th>Points</th>
              <th>Weight</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cat of data.categoryScores">
              <td>{{ getCategoryDisplayName(cat.category) }}</td>
              <td>
                <span class="cat-status-chip"
                  [class.chip-submitted]="cat.status === 'submitted'"
                  [class.chip-pending]="cat.status === 'pending_claims'">
                  {{ cat.status === 'pending_claims' ? 'Pending Claims' : 'Submitted' }}
                </span>
              </td>
              <td>
                <ng-container *ngIf="cat.score !== null; else noScore">
                  {{ cat.score | number:'1.0-1' }}
                  <span class="cat-score-sep">/</span>
                  <span class="cat-score-max">{{ cat.maxScore }}</span>
                </ng-container>
                <ng-template #noScore>
                  <span class="cat-score-tbd">Calculated Later</span>
                </ng-template>
              </td>
              <td>
                <span *ngIf="cat.weight !== null">{{ cat.weight }}%</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="cost-note" *ngIf="hasCostCategory(data.categoryScores)">
          Note: Cost category will be calculated using administrative claims data.
        </p>
      </div>


      <!-- Overall Score -->
      <div class="score-section final-score-section" *ngIf="data.finalScore !== null && !data.scoreError">
        <h2>Overall Score Preview</h2>
        <div class="final-score-display">
          <span class="score-value">{{ data.finalScore | number:'1.0-1' }}</span>
          <span class="score-outof">/ 100</span>
        </div>
        <p class="score-caption">Composite score based on submitted categories. Cost will be added by CMS when calculated.</p>
      </div>

      <!-- Submission Status -->
      <div class="score-section status-section">
        <h2>Submission Status: <span class="status-accepted">Accepted</span></h2>
        <p>All required data has been successfully submitted.</p>
        <div class="notice-banner warning-banner" *ngIf="data.finalScore !== null">
          <div class="banner-icon">
            <mat-icon>warning_amber</mat-icon>
          </div>
          <div class="banner-content">
            <strong>Note:</strong> Cost category scoring will be calculated later using administrative claims.
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="action-buttons">
        <button mat-flat-button color="primary" (click)="onReturnHome()">
          Return to Dashboard
        </button>
      </div>

    </ng-container>
  </ng-container>
</div>
